let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("11tIB"), load("b5aJh"), load("joJy8"), load("aHE9G"), load("8MT9C")]).then(() => parcelRequire('e4JZJ'));